@if (filters | async; as filters) {
  <div class="events-filter-holder">
    <div class="checkboxes-holder">
      @for (flt of filters; track flt; let i = $index) {
        <div
          class="custom-control custom-checkbox custom-control-inline"
          (click)="selectItem($event, flt)"
          (keydown.enter)="selectItem($event, flt)">
          <input
            type="checkbox"
            [id]="'radio-' + i"
            [name]="'radio-' + i"
            class="custom-control-input"
            [ngModel]="flt.selected" />
          <label class="custom-control-label" for="'radio-' + i">{{
            flt.name
          }}</label>
        </div>
      }
      @if (filters.length) {
        <div class="custom-control custom-checkbox custom-control-inline">
          <input
            [disabled]="allChecked"
            type="checkbox"
            id="radio-all"
            name="radio-all"
            class="custom-control-input"
            (change)="toggleSelectAll()"
            [ngModel]="allChecked"
            [checked]="allFilterSelected(filters)" />
          <label class="custom-control-label" for="radio-all">ALL</label>
        </div>
      }
    </div>
  </div>
}
